import { Controller } from "@hotwired/stimulus";

// Polls the current page and refreshes via Turbo when the content changes.
// Used to catch the race condition where messages finish building before
// the Turbo Stream subscription is established.
// Self-destructs after refresh or after max attempts.
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 1000 },
    maxAttempts: { type: Number, default: 10 },
  };

  connect() {
    this.attempts = 0;
    this.timer = setTimeout(() => this.check(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer);
  }

  check() {
    this.attempts++;

    // If the element is no longer in the DOM (e.g., after a morph), stop
    if (!this.element.isConnected) return;

    // If we've exceeded max attempts, give up
    if (this.attempts >= this.maxAttemptsValue) {
      this.element.remove();
      return;
    }

    // Fetch the current page and let Turbo morph it
    fetch(window.location.href, {
      headers: { Accept: "text/html" },
    })
      .then((response) => response.text())
      .then((html) => {
        // If the response no longer contains our controller, the build is done
        if (!html.includes('data-controller="poll-refresh"')) {
          Turbo.visit(window.location.href, { action: "replace" });
        } else {
          this.timer = setTimeout(() => this.check(), this.intervalValue);
        }
      })
      .catch(() => {
        this.timer = setTimeout(() => this.check(), this.intervalValue);
      });
  }
}
